(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/statistics/leaguebig/views/league-big-main.js') >= 0) return;  svs.modules.push('/components/statistics/leaguebig/views/league-big-main.js'); (function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.statistics=_svs.statistics||{};
_svs.statistics.leaguebig=_svs.statistics.leaguebig||{};
_svs.statistics.leaguebig.templates=_svs.statistics.leaguebig.templates||{};
svs.statistics.leaguebig.templates.league_big_main = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"league-big-header\">\n\n</div>\n<div class=\"league-big-content\">\n\n</div>";
},"useData":true});
Handlebars.partials['components-statistics-leaguebig-league_big_main'] = svs.statistics.leaguebig.templates.league_big_main;
})(svs, Handlebars);

 })(window);